import { FC } from 'react';

import { useDeleteDraftsMutation } from '@api/piece';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';

type Props = {
  sessionId: string;
  actionStarted: boolean;
  onActionFinish: VoidFunction;
  onClose?: VoidFunction;
};

export const Delete: FC<Props> = ({ sessionId, actionStarted, onActionFinish, onClose }) => {
  const [deleteDrafts, { isLoading }] = useDeleteDraftsMutation();

  const runDeleteAction = async () => {
    deleteDrafts({ receiveSessionId: sessionId })
      .unwrap()
      .then(() => {
        onActionFinish();
      })
      .catch((error) => {
        console.error('Error while deleting drafts:', error);
      });
  };

  const close = onClose ? onClose : onActionFinish;

  return (
    <DialogConfirmation
      maxWidth="xs"
      open={actionStarted}
      handleClose={close}
      title="Delete all images"
      content="Are you sure you would like to permanently delete all images?"
      type="error"
      acceptButtonHandleClick={runDeleteAction}
      cancelButtonHandleClick={close}
      acceptButtonTitle="Delete"
      cancelButtonTitle="Cancel"
      loading={isLoading}
    />
  );
};
